import "./AutomatedScoringStatus.less";
import {
    selectIsAiScoringConfiguredForEvaluation,
    selectIsEvaluationAssistanceConfigured,
} from "features/qualityForm/qualityFormSlice";
import {
    selectDoesDateLastChangedExist,
    selectHasEvaluationAssistanceFailed,
    selectIsAiScoringPending,
} from "features/scorable/scorableSlice";
import { EvaluationAssistanceStatus } from "./EvaluationAssistanceStatus";
import { AiScoringStatus } from "./AiScoringStatus";
import { useAppSelector } from "app/hooks";
import { shallowEqual } from "react-redux";

export function AutomatedScoringStatus() {
    const {
        isAiScoringConfigured,
        doesAiScoringDateLastChangedExist,
        isAiScoringPending,
        hasEvaluationAssistanceFailed,
        isAssistanceConfigured,
    } = useAppSelector((state) => {
        const isAiScoringConfigured =
            selectIsAiScoringConfiguredForEvaluation(state);
        const doesAiScoringDateLastChangedExist =
            selectDoesDateLastChangedExist(state);
        const isAiScoringPending = selectIsAiScoringPending(state);

        const isAssistanceConfigured =
            selectIsEvaluationAssistanceConfigured(state);

        const hasEvaluationAssistanceFailed =
            selectHasEvaluationAssistanceFailed(state);

        return {
            isAiScoringConfigured,
            doesAiScoringDateLastChangedExist,
            isAiScoringPending,
            hasEvaluationAssistanceFailed,
            isAssistanceConfigured,
        };
    }, shallowEqual);

    const showAiScoringStatus =
        isAiScoringConfigured &&
        (isAiScoringPending || doesAiScoringDateLastChangedExist);
    const showEvaluationAssistanceStatus =
        isAssistanceConfigured && !hasEvaluationAssistanceFailed;
    if (!showAiScoringStatus && !showEvaluationAssistanceStatus) {
        return null;
    }

    return (
        <div className="AutomatedScoringStatus">
            {showAiScoringStatus && <AiScoringStatus />}
            {showEvaluationAssistanceStatus && <EvaluationAssistanceStatus />}
        </div>
    );
}
